<template>
  <div class="PersonalNav">
    <div class="header">
      <div class="header_cont flex">
        <img src="../../../assets/images/home/mback.png" alt="" @click="back" style="width:20px" />
        <img src="../../../assets/image/home/logo_w.png" alt="" width="40%" @click="tohome" />
        <img src="../../../assets/images/home/umenu.png" alt="" class="rightimg" @click="openmenu" style="width:40px" />
      </div>
    </div>
    <!-- <div style="height:50px"></div> -->
    <div class="acitve">
      <span :class="pathName == 'MUserInfo' ? 'active_color' : ''" @click="toPath('MUserInfo')">个人资料</span>
      <span :class="pathName == 'MMyAchievement' ? 'active_color' : ''" @click="toPath('MMyAchievement')">我的成绩</span>
      <span :class="pathName == 'MMyCertificate' ? 'active_color' : ''" @click="toPath('MMyCertificate')">我的证书</span>
    </div>
    <transition name="fade">
      <div class="menu" v-show="menushow">
        <el-menu :default-active="path" class="menu" :router="true" @select="handleSelect">
          <el-menu-item index="userinfo">
            <span slot="title">个人资料</span>
          </el-menu-item>
          <el-menu-item index="myachievement">
            <span slot="title">我的成绩</span>
          </el-menu-item>
          <el-menu-item index="mycertificate">
            <span slot="title">我的证书</span>
          </el-menu-item>
          <el-menu-item @click="logout">
            <span slot="title">切换账号</span>
          </el-menu-item>
        </el-menu>
      </div>
    </transition>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        menushow: false,
        path: '',
        pathName: 'MUserInfo',
      }
    },
    mounted() {
      this.pathName = this.$route.name
      this.init()
    },
    watch: {
      $route: {
        handler: function (newValue) {
          this.pathName = newValue.name
        },
        deep: true,
      },
    },
    methods: {
      openmenu() {
        this.menushow = true
        this.path = this.$route.path.substring(
          this.$route.path.lastIndexOf('/') + 1
        )
      },
      handleSelect() {
        this.menushow = false
      },
      back() {
        this.$router.push({ path: '/home' })
      },
      tohome() {
        this.$router.push({ path: '/home' })
      },
      logout() {
        this.$store.commit('setUser', {})
        this.Storage.delStorage('token')
        this.Storage.delStorage('wps_user')
        this.$router.push({ path: '/login' })
      },
      toPath(name) {
        this.$router.push({ name: name })
      },
      init() {
        document.addEventListener('click', e => {
          let thisClassName = e.target.className
          if (thisClassName != 'rightimg') {
            this.menushow = false
          }
        })
      },
    },
  }
</script>
<style lang="less" scoped>
  .header {}

  .header_cont {
    padding: 5px 0;
    display: flex;
    justify-content: space-between;
    z-index: -1;
    background-color: #fd4a29;
    align-items: center;
  }

  .menu {
    position: absolute;
    right: 0px;
    width: 28vw;
    z-index: 99;
    background-color: #fff;

    /deep/.el-menu-item {
      height: 40px;
      line-height: 40px;
      color: #333;
    }

    /deep/.el-menu-item:hover {
      background-color: #fff;
      color: #fd4a29;
    }

    /deep/.el-menu-item.is-active {
      color: #fd4a29;
      background-color: #fff;
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .acitve {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;

    span {
      color: #666;
      padding: 10px;
    }
  }

  .active_color {
    background: #fd4a29;
    border-radius: 20px;
    color: #fff !important;
  }
</style>